module.exports = __webpack_public_path__ + "img/cAEVDLyE.87b128b8.svg";